import { useEffect, useState } from 'react';
import { mobileViewBreakPoint } from '../apis/constants';

const useCheckPortrait = () => {
  const getState = () => ({
    isPortrait: window.matchMedia('(orientation: portrait)').matches,
    isMobile: window.matchMedia(`(max-width: ${mobileViewBreakPoint}px)`).matches,
    isMobileAndPortrait: window.matchMedia(`(max-width: ${mobileViewBreakPoint}px) and (orientation: portrait)`).matches,
    isMobileOrPortrait: window.matchMedia(`(max-width: ${mobileViewBreakPoint}px) or (orientation: portrait)`).matches,
  });

  const [state, setState] = useState(getState());

  useEffect(() => {
    const handleChange = () => setState(getState());

    window.addEventListener('resize', handleChange);
    window.addEventListener('orientationchange', handleChange);

    return () => {
      window.removeEventListener('resize', handleChange);
      window.removeEventListener('orientationchange', handleChange);
    };
  }, []);

  return state;
};

export default useCheckPortrait;
